import styled from "styled-components";

const WaveformContainer = styled.div`
  position: relative;
`;

export default WaveformContainer;
